module.exports = __webpack_public_path__ + "static/media/programme_logo_sr.21758f0d.png";